// src/components/SummaryBar.jsx
import React from 'react';
import { Card, Badge } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined, WarningOutlined } from '@ant-design/icons';

const SummaryBar = ({
  okCount,
  to1Count, redTo1Count, yellowTo1Count,
  to2Count, redTo2Count, yellowTo2Count,
  to3Count, redTo3Count, yellowTo3Count,
  krCount, pvCount, klCount, ispCount,
  onRepairCount, brokenCount, waitPartsCount, writtenOffCount,
}) => {
  const cardStyle = {
    width: 200,
    textAlign: 'center',
    padding: '12px',
    margin: '8px',
    borderRadius: '8px',
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
  };

  const subCardStyle = {
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'space-between',
  };

  const renderStatusCard = (title, total, red, yellow) => (
    <Card style={cardStyle}>
      <h4>{title}</h4>
      <Badge count={total} style={{ backgroundColor: '#1890ff' }} />
      <div style={{ marginTop: '8px' }}>
        <div style={subCardStyle}>
          <span style={{ color: 'red' }}><WarningOutlined /> Красн.: {red}</span>
          <span style={{ color: 'orange' }}><ClockCircleOutlined /> Желт.: {yellow}</span>
        </div>
      </div>
    </Card>
  );

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
      {/* ОК статус */}
      <Card style={cardStyle}>
        <h4><CheckCircleOutlined style={{ color: 'green', marginRight: '8px' }} /> ОК</h4>
        <Badge count={okCount} style={{ backgroundColor: 'green' }} />
      </Card>

      {/* ТО1, ТО2, ТО3 */}
      {renderStatusCard('ТО1', to1Count, redTo1Count, yellowTo1Count)}
      {renderStatusCard('ТО2', to2Count, redTo2Count, yellowTo2Count)}
      {renderStatusCard('ТО3', to3Count, redTo3Count, yellowTo3Count)}

      {/* Капитальный ремонт, поверка, калибровка, испытания */}
      {renderStatusCard('Кап. Ремонт', krCount, 0, 0)}
      {renderStatusCard('Поверка', pvCount, 0, 0)}
      {renderStatusCard('Калибровка', klCount, 0, 0)}
      {renderStatusCard('Испытания', ispCount, 0, 0)}

      {/* Мануальные статусы */}
      <Card style={cardStyle}>
        <h4>На ремонте</h4>
        <Badge count={onRepairCount} style={{ backgroundColor: 'red' }} />
      </Card>
      <Card style={cardStyle}>
        <h4>Неисправен</h4>
        <Badge count={brokenCount} style={{ backgroundColor: 'red' }} />
      </Card>
      <Card style={cardStyle}>
        <h4>Ожидание зап. частей</h4>
        <Badge count={waitPartsCount} style={{ backgroundColor: 'orange' }} />
      </Card>
      <Card style={cardStyle}>
        <h4>Списан</h4>
        <Badge count={writtenOffCount} style={{ backgroundColor: 'gray' }} />
      </Card>
    </div>
  );
};

export default SummaryBar;
